export default function BulkDeleteReportInstancesConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  reportsDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    const idList = {};
    idList.ids = vm.reportInstanceIds;
    return reportsDataService.bulkDeleteReportInstances(idList).then(() => {
      alerts.success('All selected Report Instances were successfully deleted.');
      $rootScope.$broadcast(`reports.myReports.reportType.reportInstancesDeleted`, {uniqueId : vm.reportTypeId }); 
      _closeDialog($event);
      ssDialogService.hide(ssDialogService.dialogs.reports.bulkDeleteReportInstancesDialog);
    }).catch(() => {
      alerts.error('An error occurred while deleting the selected Report Instances.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.bulkDeleteReportInstancesConfirmDialog);
  }
}

BulkDeleteReportInstancesConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'reportsDataService',
  'loaderService',
  'ssDialogService'
];
